// Site/SiteForm/CharacterCounter.jsx
import React from "react";

const CharacterCounter = ({ current = "", max }) => (
  <div className={`text-xs mt-1 text-right ${current.length > max ? "font-medium text-danger-600 dark:text-danger-400" : "text-gray-500 dark:text-gray-400"}`}>
    {current.length} / {max} characters
  </div>
);

export default CharacterCounter;
